import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";

import { Translate, I18n } from "react-redux-i18n";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Form from "react-bootstrap/Form";

import { setAlert } from "../../../actions/alertActions";
import {
  updateAccountData,
  updatePreferences,
  updateVerifyEditedAccountState,
  logout,
} from "../../../actions/accountActions";
import { validateEmail } from "../../utils/Utils";

import ChangePassword from "./modals/ChangePassword";
import EditPhoneNumber from "./modals/EditPhoneNumber";

import "../../../styles/components/account/manageAccount/Info.scss";

import phone from "../../../styles/images/phone.svg";
import pencil from "../../../styles/images/pencil.svg";
import key from "../../../styles/images/key.svg";

class Info extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      edit: false,
      codeSent: false,
      validated: false,

      id: props.accountData.id,
      name: props.accountData.name || "",
      email: props.accountData.email || "",
      country: props.accountData.country || "",
      prefix: props.accountData.internationalPrefix || "",
      phone: props.accountData.phone || "",
      places: props.accountData.places || [],
      currency: props.preferences.currency,
      separator: props.preferences.separator,

      modals: {
        password: false,
        editPhone: false,
      },
    };

    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnPlaceChange = this.handleOnPlaceChange.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.accountData.internationalPrefix !==
        this.props.accountData.internationalPrefix &&
      prevProps.accountData.phone !== this.props.accountData.phone
    ) {
      this.safeSetState({
        prefix: this.props.accountData.internationalPrefix,
        phone: this.props.accountData.phone,
      });
    } else if (
      prevProps.accountData.internationalPrefix ===
        this.props.accountData.internationalPrefix &&
      prevProps.accountData.phone !== this.props.accountData.phone
    ) {
      this.safeSetState({
        phone: this.props.accountData.phone,
      });
    } else if (
      prevProps.accountData.internationalPrefix !==
        this.props.accountData.internationalPrefix &&
      prevProps.accountData.phone === this.props.accountData.phone
    ) {
      this.safeSetState({
        prefix: this.props.accountData.internationalPrefix,
      });
    } else if (prevProps.accountData.email !== this.props.accountData.email) {
      this.safeSetState({
        email: this.props.accountData.email,
      });
    }
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting");
    this.resetState();
  }

  handleOnChange(e) {
    this.safeSetState({
      [e.target.name]: e.target.value,
    });
  }

  handleOnPlaceChange(e) {
    const t = e.target;
    let place = Object.assign(
      {},
      this.state.places.find((p) => p.name === t.name) || {
        name: t.name,
      }
    );
    place.address = t.value;
    this.safeSetState(
      (prevState) => ({
        places: [...prevState.places.filter((p) => p.name !== t.name), place],
      }),
      () => console.log(this.state.places)
    );
  }

  resetState() {
    this.safeSetState({
      edit: false,
      codeSent: false,

      id: this.props.accountData.id,
      name: this.props.accountData.name || "",
      email: this.props.accountData.email || "",
      country: this.props.accountData.country || "",
      phone: this.props.accountData.phone || "",
      places: this.props.accountData.places || [],
      currency: this.props.preferences.currency,
      separator: this.props.preferences.separator,
      prefix: this.props.accountData.internationalPrefix || "",

      modals: {
        password: false,
        editPhone: false,
      },
    });
  }

  handleOnSubmit(e) {
    e.preventDefault();

    const form = e.target;

    this.safeSetState({ validated: true }, () => {
      if (form.checkValidity() !== false) {
        if (
          this.state.currency !== this.props.preferences.currency ||
          this.state.separator !== this.props.preferences.separator
        ) {
          this.safeSetState({ edit: false }, () => {
            this.props.updatePreferences({
              currency: this.state.currency,
              separator: this.state.separator,
            });
          });
        }

        if (this.state.name !== this.props.accountData.name) {
          const patch = {
            name: this.state.name,
            email: this.state.email,
            mobile: this.state.phone,
            internationalPrefix: this.state.prefix,
          };

          axios
            .patch(
              this.props.brand?.brandName === "EVIO"
                ? "/api/private/users/backOffice"
                : "/api/private/users",
              patch,
              {
                cancelToken: new CancelToken((c) => (this.cancel = c)),
              }
            )
            .then((res) => {
              if (res.status === 200) {
                this.safeSetState({ edit: false }, () => {
                  if (
                    res.data && this.props.brand?.brandName === "EVIO"
                      ? res.data.message
                      : I18n.t(res.data.message.message)
                  ) {
                    this.props.setAlert(
                      this.props.brand?.brandName === "EVIO"
                        ? I18n.t(res.data.message)
                        : I18n.t(res.data.message.message),
                      "primary"
                    );
                  }
                  this.props.updateAccountData(
                    this.props.accountData.internationalPrefix,
                    this.state.phone
                  );
                });
              }
            })
            .catch((err) => {
              if (err.response && err.response.data)
                this.safeSetState({
                  name: this.props.accountData.name,
                  email: this.props.accountData.email,
                });
              this.props.setAlert(I18n.t(err.response.data.message), "danger");
            });
        }

        if (this.state.email !== this.props.accountData.email) {
          if (!validateEmail(this.state.email)) {
            this.safeSetState({ email: this.props.accountData.email }, () => {
              this.props.setAlert(I18n.t("signUp_InvalidEmail"), "danger");
            });
            return;
          } else {
            const patch = {
              name: this.state.name,
              email: this.state.email,
              mobile: this.state.phone,
              internationalPrefix: this.state.prefix,
            };

            axios
              .patch(
                this.props.brand?.brandName === "EVIO"
                  ? "/api/private/users/backOffice"
                  : "/api/private/users",
                patch,
                {
                  cancelToken: new CancelToken((c) => (this.cancel = c)),
                }
              )
              .then((res) => {
                if (res.status === 200) {
                  this.safeSetState({ edit: false, codeSent: true }, () => {
                    if (
                      res.data && this.props.brand?.brandName === "EVIO"
                        ? res.data.message
                        : I18n.t(res.data.message.message)
                    ) {
                      this.props.setAlert(I18n.t("email_updated"), "primary");
                    }
                    this.props.logout();
                  });
                }
              })
              .catch((err) => {
                if (err.response && err.response.data)
                  this.safeSetState({
                    name: this.props.accountData.name,
                    email: this.props.accountData.email,
                  });
                this.props.setAlert(
                  I18n.t(err.response.data.message),
                  "danger"
                );
              });
          }
        }
      }
    });
  }

  setModal(modal, bool, callback) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState(
      {
        modals: newModals,
      },
      callback
    );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <div id="info" className="evio-container">
        <div className="top-bar">
          <p className="title">
            <Translate value="accountDetails_information" />
          </p>
          <button
            type="submit"
            form="info-form"
            className={this.state.edit ? "save-btn" : "clear"}
            onClick={() => {
              this.safeSetState((prevState) => ({
                edit: !prevState.edit,
              }));
            }}
          >
            {this.state.edit ? (
              <Translate value="editAccount_saveButton" />
            ) : (
              <img src={pencil} alt={I18n.t("editAccount_editLabel")} />
            )}
          </button>
        </div>
        <Form
          id="info-form"
          validated={this.state.validated}
          noValidate
          onSubmit={this.handleOnSubmit}
        >
          <Form.Group className="info-field">
            <Form.Label>
              <Translate value="editAccount_nameLabel" />
            </Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={
                this.state.name && this.state.name !== ""
                  ? this.state.name
                  : this.state.edit
                  ? ""
                  : "-"
              }
              onChange={this.handleOnChange}
              disabled={!this.state.edit}
            />
          </Form.Group>
          <Form.Group className="info-field" controlId="prefix">
            <Form.Label>
              <Translate value="editAccount_prefixLabel" />
            </Form.Label>
            <Form.Control
              as={PhoneInput}
              autoFormat={false}
              country={this.state.country}
              countryCodeEditable={false}
              inputProps={{
                name: "prefix",
                required: true,
                autoFocus: true,
              }}
              value={this.state.prefix}
              placeholder=""
              required
              disabled={true}
            />
          </Form.Group>
          <Form.Group className="info-field">
            <Form.Label>
              <Translate value="editAccount_phoneNumber" />
            </Form.Label>
            <Form.Control
              type="text"
              name="phone"
              value={
                this.state.phone && this.state.phone !== ""
                  ? this.state.phone
                  : this.state.edit
                  ? ""
                  : "-"
              }
              disabled={true}
            />
          </Form.Group>
          <Form.Group className="info-field">
            <Form.Label>
              <Translate value="editAccount_emailLabel" />
            </Form.Label>
            <Form.Control
              type="text"
              name="email"
              value={
                this.state.email && this.state.email !== ""
                  ? this.state.email
                  : this.state.edit
                  ? ""
                  : "-"
              }
              onChange={this.handleOnChange}
              disabled={!this.state.edit}
            />
          </Form.Group>
        </Form>

        <div className="password-menu">
          <button
            type="button"
            className="clear"
            onClick={() => this.setModal("password", true)}
          >
            <img src={key} className="icon" alt="" />
            <p>
              <Translate value="accountDetails_changePassword" />
            </p>
          </button>
          <button
            type="button"
            className="clear"
            onClick={() => this.setModal("editPhone", true)}
          >
            <img src={phone} className="icon" alt="" />
            <p>
              <Translate value="accountDetails_editPhone" />
            </p>
          </button>
        </div>

        <ChangePassword
          show={this.state.modals.password}
          onHide={() => this.setModal("password", false)}
        />
        <EditPhoneNumber
          show={this.state.modals.editPhone}
          onHide={() => this.setModal("editPhone", false)}
          name={this.state.name}
          email={this.state.email}
          prefix={this.state.prefix}
          phone={this.state.phone}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  language: state.language,
  account: state.account,
  accountData: state.account.accountData,
  preferences: state.account.preferences,
  brand: state.app.brand,
});

export default connect(mapStateToProps, {
  setAlert,
  updateAccountData,
  updatePreferences,
  updateVerifyEditedAccountState,
  logout,
})(Info);
